<template>
  <Transition name="fade">
    <Button
      v-if="showLeftButton"
      variant="overlay"
      class="button-position left z-10"
      @click="previousBackground"
      :disabled="editorStore.isGeneratingBackground"
    >
      <template #start>
        <ArrowLeftIcon />
      </template>
      <template #default v-if="editorStore.isGeneratingBackground">
        <span>Previous</span>
      </template>
    </Button>
  </Transition>
  <Transition name="fade">
    <Button
      v-if="showRightButton"
      variant="overlay"
      class="button-position right z-10"
      @click="nextBackground"
      :disabled="editorStore.isGeneratingBackground"
    >
      <template #end>
        <ArrowRightIcon />
      </template>
      <template #default v-if="editorStore.isGeneratingBackground">
        <span>Next</span>
      </template>
    </Button>
  </Transition>
</template>

<script setup lang="ts">
import { useMagicBackground } from "@/composables/magic_background";
import { useEditorStore } from "@/stores/editor_store";
import { PersistentStore } from "@/stores/persistent_store";
import { Button, ArrowLeftIcon, ArrowRightIcon } from "prism";
import { computed } from "vue";

interface Props {
  persistentStore: PersistentStore;
}

const props = defineProps<Props>();
const persistentStore = computed(() => props.persistentStore);

const { hasNoMagicBackgroundsSelected, isLastBackground, previousBackground, nextBackground } =
  useMagicBackground(persistentStore);

const editorStore = useEditorStore();

const showLeftButton = computed(() => {
  return !hasNoMagicBackgroundsSelected.value || editorStore.isGeneratingBackground;
});

const showRightButton = computed(() => {
  return !isLastBackground.value || editorStore.isGeneratingBackground || hasNoMagicBackgroundsSelected.value;
});
</script>

<style scoped lang="scss">
.button-position {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  &.left {
    left: 1rem;
  }

  &.right {
    right: 1rem;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
